import React from 'react';
import { motion } from 'framer-motion';

const CallToAction: React.FC = () => {
  const whatsappNumber = '5541999119143';
  
  const handleWhatsAppContact = (serviceType?: string) => {
    let message = 'Olá! Gostaria de solicitar uma proposta personalizada.';
    
    if (serviceType) {
      message = `Olá! Tenho interesse em ${serviceType} e gostaria de receber uma proposta personalizada.`;
    }
    
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/${whatsappNumber}?text=${encodedMessage}`, '_blank');
  };

  const services = [
    'Design de Interiores',
    'Visual Merchandising', 
    'Gestão Ambiental',
    'Marketing Estratégico',
    'Consultorias',
    'Cursos'
  ];

  return (
    <section id="contact" className="section relative py-24">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-neutral-dark bg-opacity-70"></div>
        <img 
          src="https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80" 
          alt="Design de Interiores" 
          className="w-full h-full object-cover"
        />
      </div>

      <div className="container relative z-10">
        <div className="max-w-4xl mx-auto text-center text-white">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-3xl md:text-5xl font-bold mb-6"
          >
            Transforme seu espaço ou negócio hoje
          </motion.h2>
          
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-xl text-white/90 mb-12"
          >
            Estamos prontos para ajudar você a alcançar seus objetivos através de design estratégico e soluções personalizadas
          </motion.p>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="bg-white/10 backdrop-blur-sm p-8 md:p-12 rounded-lg shadow-lg"
          >
            {/* WhatsApp Contact Options */}
            <div className="space-y-6">
              {/* Main Contact Button */}
              <div className="mb-8">
                <button 
                  onClick={() => handleWhatsAppContact()}
                  className="w-full bg-primary hover:bg-opacity-90 text-white font-medium rounded-md px-6 py-4 transition-all duration-300 transform hover:scale-[1.01] text-lg"
                >
                  💬 Entrar em Contato via WhatsApp
                </button>
              </div>

              {/* Service-specific buttons */}
              <div className="grid md:grid-cols-2 gap-4">
                {services.map((service, index) => (
                  <button
                    key={index}
                    onClick={() => handleWhatsAppContact(service)}
                    className="bg-white/20 hover:bg-white/30 border border-white/30 rounded-md px-4 py-3 text-white transition-all duration-300 hover:scale-[1.02]"
                  >
                    {service}
                  </button>
                ))}
              </div>

              {/* Contact Information */}
              <div className="mt-8 pt-8 border-t border-white/20">
                <div className="flex flex-col md:flex-row justify-center items-center gap-6 text-white/80">
                  <div className="flex items-center gap-2">
                    <span className="text-primary">📞</span>
                    <span>+55 41 99911-9143</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="text-primary">📍</span>
                    <span>Curitiba - PR</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="text-primary">⏰</span>
                    <span>Seg - Sex: 9h às 18h</span>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction; 